import React from 'react';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../../components/table/TableColumnImg';
import Select from '../../../../../../components/input/Select';
import Button from '../../../../../../components/Button';
import TableFilterInput from '../../../../../../components/table/TableFilterInput';
import { openNewWindow, setColumnWidth, setDetailPageUrl } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';
import Anchor from '../../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { BRAND_DETAIL_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import {
  ACCOUNT_SELLER_TAG_REQUEST_STATUS_SELECT_LIST,
  ACCOUNT_SELLER_STATUS_TEXT,
} from '../../../../../../constants/service/app/accountSellerConstants';

/**
 *  디비에 등록된 모든 브랜드를 조회하는 테이블
 */
const columns = (data) => {
  const { list, filterOption, onFilter, getBrandTagColumnTagList } = data;

  return [
    {
      accessor: 'storeId',
      Header: '검수하기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="검수하기"
          onClick={() => openNewWindow(setDetailPageUrl(BRAND_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'url',
      Header: '대표이미지',
      fixed: 'left',
      width: 150,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      sortable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드 명',
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'storeName'),
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => ACCOUNT_SELLER_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={ACCOUNT_SELLER_TAG_REQUEST_STATUS_SELECT_LIST}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      Header: '태그',
      Cell: (row) =>
        row.original.isTagExists ? (
          <Anchor
            text="태그 보기"
            isUnderLine
            color="primary"
            onClick={() => getBrandTagColumnTagList({ storeId: row.original.storeId })}
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'companyName',
      Header: '상호/법인명 ',
      width: 130,
    },
    {
      accessor: 'tagGroupName',
      Header: '검수 요청한 브랜드 태그 그룹',
    },
    {
      accessor: 'requestTagName',
      Header: '검수 요청한 태그',
    },
    {
      accessor: 'confirmStoreTagCreateDate',
      Header: '최근 검수 요청 일시',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
